// extracted by mini-css-extract-plugin
export default {"scope":"reset-module-scope-hs2tE","reset":"reset-module-reset-u2vwI reset-module-scope-hs2tE","root":"reset-module-root-dW9CY reset-module-reset-u2vwI reset-module-scope-hs2tE"};